// extracted by mini-css-extract-plugin
export default {"goBack":"CreateNewVehiclePage_goBack__c4P9S","wrapper":"CreateNewVehiclePage_wrapper__6bdlp","form":"CreateNewVehiclePage_form__i3sco"};